module.exports = __webpack_public_path__ + "img/zh_hk.80885518.png";